import React from 'react';

import { Button, Group } from '@mantine/core';

import { SignUpOrUpgradeButton } from '@marketing/components/resourcepro-blocks/SignUpOrUpgradeButton';
import { Section } from '@marketing/components/section/Section';
import { SectionHeader } from '@marketing/components/section/SectionHeader';
import { SectionSpacer } from '@marketing/components/section/SectionSpacer';

import { InternalTrackingService } from 'services/InternalTrackingService';

export const ResourceProFooterBlock = ({
    variant = 'light',
    bg,
    signup = false,
    pricing = true,
    exhibit = false,
}: {
    variant?: 'default' | 'light' | 'dark';
    bg?: string;
    signup?: boolean;
    pricing?: boolean;
    exhibit?: boolean;
}) => {
    return (
        <Section variant={variant} bg={bg}>
            <SectionHeader title="Ready to Join?" />
            <SectionSpacer size="xs" />
            <Group gap="md" justify="center">
                <SignUpOrUpgradeButton signup={signup} />

                {pricing && (
                    <Button
                        size="lg"
                        variant={variant === 'dark' ? 'white' : 'outline'}
                        component="a"
                        href="/resourcepro/pricing"
                    >
                        Discover Pricing
                    </Button>
                )}

                {exhibit && (
                    <Button
                        size="lg"
                        variant={variant === 'dark' ? 'white' : 'outline'}
                        component="a"
                        href="https://www.re-plus.com/exhibit/"
                        {...InternalTrackingService.link('navigation.replus.exhibit')}
                    >
                        Exhibit at an RE+ Event
                    </Button>
                )}
            </Group>
        </Section>
    );
};
